import React from 'react';
import closeIcon from "../../../assets/images/close.png";
import {useDispatch} from "react-redux";

import {triggerSettingsView} from "../../../store/settings/actions";

interface Props {
    onClose: () => void
}

const SettingsTitleComponent: React.FC<Props> = ({onClose}) => {
    return(
        <div className='pos-rel'>
            <div className='settings-title'>
                Settings
            </div>
            <div className='close-icon pointer'
                 onClick={ onClose }>
                <img src={ closeIcon } alt="close-icon" width='9px' />
            </div>
        </div>
    )
}

export default SettingsTitleComponent